import { render, staticRenderFns } from "./InspectionAction.vue?vue&type=template&id=34975f21&scoped=true"
import script from "./InspectionAction.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionAction.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionAction.vue?vue&type=style&index=0&id=34975f21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34975f21",
  null
  
)

export default component.exports